<template>
  <div>
    <!-- <van-swipe
      @change="onChange"
      class="my-swipe"
      :autoplay="3000"
      indicator-color="white"
      :show-indicator="false"
      :show-indicators="false"
    >
      <van-swipe-item>1</van-swipe-item>
      <van-swipe-item>2</van-swipe-item>
      <van-swipe-item>3</van-swipe-item>
      <van-swipe-item>4</van-swipe-item>
    </van-swipe> -->
    <div class="container">
      <div class="header">header</div>
      <div class="main">
        <div>开始</div>
        
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        <div>44444444444444</div>
        
      
        <div>结束</div>
      </div>
      <div class="footer">footer</div>
    </div>
  </div>
</template>
<script>
import { freeQuestionBank } from "../api/api";
export default {
  created() {
    var data = {
      appID: "1682",
      queryHistory: 1,
      queryTestInfo: 1,
      queryKnowledge: 0,
      guid: "oWatGg2APeR1xhYn1SeVzbknnQfcOetv504343938"
    };
    freeQuestionBank(data).then(res => {
      
    });
  },
  methods: {
    onChange(index) {
      
    }
  }
};
</script>
<style>
/* .my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  height: 100vh;
  background-color: #39a9ed;
} */
body {
  padding: 0;
  margin: 0;
}
.container {
  height: calc(100vh);
  background-color: black;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  /* margin: 100px 0; */
}
.header {
  width: 100%;
  height: 100px;
  background-color: #e77c8e;
  position: fixed;
}
.main {
  width: 100%;
  flex: 1;
  background-color: #2bae85;
  margin:100px 0;
  
}
.footer {
  width: 100%;
  height: 100px;
  background-color: #7a7374;
  position: fixed;
  bottom: 0;
}
</style>
